<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-form
              :model="formData"
              class="formData"
              label-width="7em">
              <jm-form-options
                :options="options"
                :option-data="formData"
                :const-dict="constDict"/>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="reset">重置</el-button>
                <el-button
                  type="primary"
                  @click="save">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jmFormOptions from '@/components/data/formOptions';

let options = [
  {
    visible: 'act_title',
    field: 'act_title',
    label: '活动名称',
    placeholder: '活动名称',
    component: 'input',
    column: [24, 24, 24, 24]
  },
  {
    visible: 'act_action',
    field: 'act_action',
    label: '用户行为设置',
    placeholder: '用户行为设置',
    component: 'mgSelect',
    multiple: true,
    constKey: 'act_action',
    column: [24, 24, 12, 12]
  },
  {
    visible: 'act_creater',
    field: 'act_creater',
    label: '创建人绑定',
    placeholder: '创建人绑定',
    component: 'mgSelect',
    multiple: true,
    constKey: 'act_creater',
    column: [24, 24, 12, 12]
  }
];

let formData = {
  act_title: '',
  id: 0,
  act_data: '',
  act_creater: [],
  act_action: []
};

let constDict = {
  view_userid: []
};

export default {
  data() {
    return {
      options,
      constDict,
      formData: {}
    };
  },
  components: { jmFormOptions },
  methods: {
    // 初始默认搜索值
    setFormData() {
      this.formData = Object.assign({}, formData);
    },
    setConstDict() {
      this.constDict = Object.assign({}, constDict);
    },
    reset() {
      this.setFormData();
    },
    save() {
      this.$http
        ._post({
          url: '/index/b_i_action_group/edit',
          data: this.formData
        })
        .then(() => {
          this.$message.success('保存成功');
          this.$router.push({ name: 'actionGroupDataList' });
        });
    }
  },
  created() {
    this.$http
      ._get({
        url: `/index/b_i_action_group/show?id=${this.$route.params.id}`
      })
      .then(({ data }) => {
        if (typeof data.from_data !== 'undefined') {
          formData = data.from_data;
          this.setFormData();
        }
        this.constDict = data.const_dict;
      }, ({ data }) => {
        if (!data.const_dict) {
          this.$alert('数据问题', '', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.push({ name: 'editStudent', params: { id: this.$route.params.id } });
            }
          });
        }
      });
  },
  watch: {
  }
};
</script>
<style>

</style>
